var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "title-cadastro" }, [
      _vm._v("Dados do cadastro")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-collapse" },
      [
        _c(
          "el-collapse",
          { on: { change: _vm.handleChange } },
          [
            _c(
              "el-collapse-item",
              { attrs: { title: "Cadastrante", name: "CASTRANTE" } },
              [
                _c("Cadastrante", {
                  attrs: { cadastrante: _vm.cadastro.cadastrante }
                })
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isCadastroEmpresa
              ? _c(
                  "el-collapse-item",
                  { attrs: { title: "Proprietário", name: "PROPRIETARIO" } },
                  [
                    _c("Proprietario", {
                      attrs: { proprietario: _vm.cadastro.proprietario }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-collapse-item",
              { attrs: { title: "Imóvel", name: "IMOVEL" } },
              [_c("Imovel", { attrs: { imovel: _vm.cadastro.imovel } })],
              1
            ),
            _vm._v(" "),
            _c(
              "el-collapse-item",
              { attrs: { title: "Uso do solo", name: "USO_DO_SOLO" } },
              [_c("UsoDoSolo", { attrs: { usoDoSolo: _vm.cadastro.usoSolo } })],
              1
            ),
            _vm._v(" "),
            _c(
              "el-collapse-item",
              { attrs: { title: "Práticas", name: "PRATICAS" } },
              [_c("Praticas", { attrs: { praticas: _vm.cadastro.praticas } })],
              1
            ),
            _vm._v(" "),
            _c(
              "el-collapse-item",
              {
                attrs: {
                  title: "Georreferenciamento",
                  name: "GEORREFERENCIAMENTO"
                }
              },
              [
                _c("Georreferenciamento", {
                  attrs: { dados: _vm.dadosGeorreferenciamento }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-collapse-item",
              { attrs: { title: "Galeria", name: "GALERIA" } },
              [
                _c("Galeria", {
                  attrs: {
                    cadastro: _vm.cadastro,
                    protocolo: _vm.protocolo,
                    dados: _vm.dadosGaleria
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64a0a396", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a0a396","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Cadastro.vue
// module id = null
// module chunks = 